import React from "react";
import PropTypes from "prop-types";
import BondObligeeInformationBase from "../../../../features/bonds/shared/components/BondObligeeInformationBase";
import { getObligeeSurfaceConfig } from "../../../../features/bonds/shared/obligeeInformationConfig";
import BlanketHistoricGoogleAutoComplete from "./BlanketHistoricGoogleAutoComplete";

const BlanketHistoricObligeeInformation = (props) => (
  <BondObligeeInformationBase
    cfg={getObligeeSurfaceConfig("blanket")}
    GoogleAutoComplete={BlanketHistoricGoogleAutoComplete}
    {...props}
  />
);

BlanketHistoricObligeeInformation.propTypes = {
  control: PropTypes.object.isRequired,
  obligees: PropTypes.array,
  loadingObligees: PropTypes.bool,
  openObligeeDialog: PropTypes.bool,
  setOpenObligeeDialog: PropTypes.func.isRequired,
  newObligee: PropTypes.object,
  setNewObligee: PropTypes.func.isRequired,
  allCities: PropTypes.array,
  allStates: PropTypes.array,
  handleObligeeGoogleCallback: PropTypes.func.isRequired,
  handleAddObligee: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
};

export default BlanketHistoricObligeeInformation;
